"use client";

export default function RootLayout({ children }) {
  return <main className="pt-[5.125rem]">{children}</main>;
}
